import gsap from 'gsap';

$('body').on('initScripts pageTransitionComplete', function() {
    let animDuration = 0.5;

    const $logo = $('.site-footer__logo'),
        $icon = $('.site-footer__logo .sprog-icon');

    $.fn.initAnimations = function () {
        const $iconBarTop = $('span:nth-child(1)', this),
            $iconBarMiddle = $('span:nth-child(2)', this);

        const tlIn = gsap.timeline({
            paused: true
        });

        const tlOut = gsap.timeline({
            paused: true,
            onComplete: () => {
                tlIn.pause(0);
                tlOut.pause(0);
                gsap.set($iconBarTop, { clearProps: 'all' });
                gsap.set($iconBarMiddle, { clearProps: 'all' });
            }
        })

        tlIn.set($iconBarTop, { clearProps: 'all' });
        tlIn.set($iconBarMiddle, { clearProps: 'all' });

        tlIn.to($iconBarTop, {
            duration: animDuration * 1.5,
            ease: 'power1.out',
            bottom: 0,
            transform: 'none'
        })
        .to($iconBarMiddle, {
            duration: animDuration * 1.5,
            ease: 'power1.out',
            bottom: 0,
            transform: 'none'
        }, '<');

        tlOut.to($iconBarTop, {
            duration: animDuration,
            delay: animDuration * 0.25,
            ease: 'power1.out',
            bottom: '110%'
        })
        .to($iconBarMiddle, {
            duration: animDuration,
            ease: 'power1.out',
            bottom: '52.5%',
        }, '<')
        .to($iconBarMiddle, {
            duration: animDuration * 2,
            ease: 'power1.Out',
            rotation: 180,
        }, '<')
        .to($iconBarMiddle, {
            duration: animDuration,
            ease: 'power1.in',
            bottom: 0,
        }, '-='+animDuration)
        .to($iconBarTop, {
            duration: animDuration * 0.875,
            ease: 'power1.in',
            bottom: 0
        }, '<')
        // reset to starting position
        .to($iconBarMiddle, {
            duration: animDuration * 1.5,
            ease: 'power1.inOut',
            bottom: '50%',
            rotation: 225,
            transform: 'translate3d(0, 50%, 0)'
        })
        .to($iconBarTop, {
            duration: animDuration * 1.5,
            ease: 'power1.inOut',
            bottom: '100%',
            transform: 'translate3d(0, 100%, 0)'
        }, '<');

        $logo.on('mouseenter', () => {
            if (tlOut.isActive()) return;
            tlIn.timeScale(1).play();
        }).on('mouseleave', () => {
            if (tlIn.isActive()) {
                tlIn.timeScale(1.5).reverse();
            } else {
                if (tlIn.progress() > 0) {
                    tlOut.play();
                }
            }
        });
    }

    if ($icon.length > 0) {
        if (!prefersReducedMotion) {
            $icon.initAnimations();
        }
    }
});
